import React, { useState } from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { Checkbox } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface Props {
  checked: string;
  label?: string;
}

const Index = ({ checked = "false", label = "", ...props }: Props) => {
  const booleanifiedString = JSON.parse(checked);
  const [isChecked, setIsChecked] = useState(booleanifiedString);

  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <Checkbox
        checked={isChecked}
        label={label}
        onChange={() => setIsChecked(!isChecked)}
      />
    </ThemeProvider>
  );
};

Index.propTypes = {
  checked: PropTypes.string.isRequired,
  label: PropTypes.string
};

customElements.define(
  "ibinder-checkbox",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
